<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="cbp-spmenu-push">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="banner-info">
          <span>会社情報</span>
        </div>
      </div>
    </div>
    <!-- banner-bottom -->
    <section>
      <!-- 公司簡介 -->
      <section id="lsyg">
        <div class="banner-bottom">
          <div class="onlyPC">
            <div class="col-lg-5 banner-bottom-left1">
              <div class="banner-bottom-left1-grid">
                <h3>沿革</h3>
                <div class="progress progress1">
                  <div
                    class="progress-bar progress-bar1"
                    role="progressbar"
                    aria-valuenow="40"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 40%"
                  >
                    <span class="sr-only">40% Complete</span>
                  </div>
                </div>
                <p>
                  華胤（Far
                  East）は1994年、米国・日本・オーストラリアなどの鉄骨構造規格に精通したエンジニアチームにより設立されました。創業当初は、中国大陸の華南および華東地域を中心に、台湾系および外資系企業向けに、鉄骨構造の設計・製作・施工サービスを提供してきました。主な取引先には、宏碁（Acer）、金仁宝（Kinpo）、南亞（Nan
                  Ya Plastics）、台光電（Taiwan Union Technology）、威盛（VIA
                  Technologies）などの ICT
                  分野の著名企業に加え、半導体業界を代表する企業として、台湾積体電路製造（TSMC）、サムスン電子、インテルなどが含まれています。30年以上にわたる経験と技術の蓄積を経て、現在では従業員数500名以上を擁し、事業領域は南北米、オーストラリア、ヨーロッパへと拡大しました。製品は30か国以上に輸出され、これまでに4,000件を超える鉄骨構造プロジェクトを完工しています。当社の実績は、製造工場、物流施設、住宅・商業ビル、公共建築、石油化学、エネルギー・電力、鉱業・金属、高層建築など、幅広い産業分野に及んでいます。
                </p>
              </div>
            </div>
            <div class="col-lg-7 banner-bottom-left2">
              <div class="grid">
                <figure>
                  <img
                    src="@/components/img/gyhy/3.jpg"
                    alt=""
                    class="showImg"
                  />
                </figure>
              </div>
            </div>
          </div>

          <div class="clearfix"></div>
        </div>
      </section>

      <!-- 華胤目標 -->
      <section>
        <div id="hymb">
          <div class="banner-bottom1 visible-lg">
            <div class="onlyPC">
              <div class="col-lg-7 banner-bottom-left2 banner-bottom1-left2">
                <div class="grid">
                  <figure>
                    <img
                      src="@/components/img/gyhy/2.jpg"
                      alt=""
                      class="showImg"
                    />
                  </figure>
                </div>
              </div>
              <div class="col-lg-5 banner-bottom-lft1">
                <h4>企業理念</h4>
                <div class="progress progress1 progress2">
                  <div
                    class="progress-bar progress-bar1"
                    role="progressbar"
                    aria-valuenow="40"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 40%"
                  >
                    <span class="sr-only">40% Complete</span>
                  </div>
                </div>
                <p>
                  華胤の使命は、長年にわたり蓄積してきた専門的な知見と技術力を活かし、高品質な鉄骨構造製品および優れた建設プロジェクトサービスを提供することで、お客様の持続的な事業発展に貢献することです。当社は、技術革新と高度な設計力、ならびに多様な顧客ニーズに応える柔軟なサービスを通じて、この使命の実現に取り組んでいます。生産においては安全性を最優先とし、高い品質水準の維持、確実な納期遵守、徹底した工程管理を一貫して実行しています。
                </p>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
          <div class="banner-bottom1 hidden-lg">
            <div class="onlyPC">
              <div class="col-lg-5 banner-bottom-lft1">
                <h4>企業理念</h4>
                <div class="progress progress1 progress2">
                  <div
                    class="progress-bar progress-bar1"
                    role="progressbar"
                    aria-valuenow="40"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 40%"
                  >
                    <span class="sr-only">40% Complete</span>
                  </div>
                </div>
                <p>
                  華胤の使命は、長年にわたり蓄積してきた専門的な知見と技術力を活かし、高品質な鉄骨構造製品および優れた建設プロジェクトサービスを提供することで、お客様の持続的な事業発展に貢献することです。当社は、技術革新と高度な設計力、ならびに多様な顧客ニーズに応える柔軟なサービスを通じて、この使命の実現に取り組んでいます。生産においては安全性を最優先とし、高い品質水準の維持、確実な納期遵守、徹底した工程管理を一貫して実行しています。
                </p>
              </div>
              <div class="col-lg-7 banner-bottom-left2 banner-bottom1-left2">
                <div class="grid">
                  <figure>
                    <img
                      src="@/components/img/gyhy/2.jpg"
                      alt=""
                      class="showImg"
                    />
                  </figure>
                </div>
              </div>

              <div class="clearfix"></div>
            </div>
          </div>
        </div>

        <div class="banner-bottom1" id="hyyj">
          <div class="onlyPC">
            <div class="col-lg-5 banner-bottom-lft1">
              <h4>ビジョン</h4>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
              <p>
                華胤のビジョンは、世界トップクラスの鉄骨構造建築グループとなることです。絶え間ない工法の高度化と技術革新を通じて、鉄骨構造建築が有する環境性能、経済性、安全性、意匠性、ならびに資材のリサイクル性といった特長を最大限に活かし、お客様とともに、持続可能で価値ある象徴的なプロジェクトの実現を目指しています。これにより、人々にとって快適で質の高い働く環境・生活環境の創出に貢献してまいります。
              </p>
            </div>
            <div class="col-lg-7 banner-bottom-left2 banner-bottom1-left2">
              <div class="grid">
                <figure>
                  <img
                    src="@/components/img/gyhy/4.jpg"
                    alt=""
                    class="showImg"
                  />
                </figure>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </section>
      <!-- 工廠介紹 -->
      <section id="esg">
        <div class="container gradient-background">
          <!-- ESG -->
          <div class="row">
            <div class="col-lg-12 rzTop">
              <h1><span>環境・社会・ガバナンス</span></h1>
              <p class="rzp">
                Far East は、第三世代となる海安工場において、ESG
                戦略を製造プロセス全体にわたり本格的に実装しています。建材の選定からエネルギー構成に至るまで、低炭素化および資源循環の概念を体系的に導入し、持続可能な製造体制を構築しています。工場建屋の主体となる鉄骨構造には、第二世代の昆山工場から解体・回収した構造部材を大幅に再利用しており、鉄骨構造のモジュール化および再利用可能性という特長を最大限に活かしています。これにより、新規材料の使用量を抑制するとともに、建設段階における
                CO₂ 排出量の大幅な削減を実現しています。
              </p>
              <p class="rzp">
                エネルギー面では、海安工場の屋上にグループ傘下の国盛新能源（GS
                Solar
                Power）が構築した太陽光発電システムを設置し、現在では工場全体の50％以上の電力を安定的に供給しています。再生可能エネルギーの利用比率を高めることで、環境負荷の低減と事業運営のレジリエンス強化の両立を図っています。さらに同工場では、業界内でも採用例の少ない水幕移動式の環境対応型塗装ブースを導入しています。本設備により、約50％の
                CO₂
                排出削減および約70％の揮発性有機化合物（VOC）排出削減を達成し、作業環境の大幅な改善と環境配慮への高い実行力を体現しています。
              </p>
              <p class="rzp">
                Far East は、ISO 14001（環境マネジメント）および ISO
                45001（労働安全衛生）の国際認証を取得しているほか、EU EN
                1090（鋼構造製作）および ISO
                3834（溶接品質）の各規格にも準拠しています。これらの高水準なガバナンス体制を基盤として、企業の持続可能性とグリーン・マニュファクチャリングを継続的に推進し、鋼構造業界における信頼される
                ESG 実践企業を目指しています。
              </p>
            </div>
            <div class="col-lg-12 esgImgCon">
              <img src="@/components/img/gyhy/esg.png" alt="" class="esgImg" />
            </div>
          </div>

          <!-- 工廠介紹 -->
          <div class="row" id="gcjs">
            <div class="col-lg-12 rzTop">
              <h1><span>工場紹介</span></h1>
              <p>
                Far
                East（華胤／かいん）は、アジア地域に複数の専門的な鉄骨構造製造工場を有し、各地域の顧客ニーズおよびプロジェクト特性に応じた最適な供給体制を構築しています。中でも、江蘇省海安に位置する製造拠点は、敷地面積125,000㎡、建屋面積63,000㎡を有し、年間50,000トンの鉄骨構造部材および30,000トンのカラー鋼成形部材の生産能力を備えています。同工場では、先進的な自動化加工設備と、最新の環境規制に適合した塗装設備を導入しており、大型・高重量の鉄骨構造部材の製作にも対応可能です。Far
                East
                は、創業以来の中核となる価値観である「継続的なイノベーション」「品質の改善」「誠実なサービス」を基盤として、高い実行力をもって、お客様に信頼される存在であり続けます。
              </p>
              <div class="spaceCon">
                <div
                  class="col-lg-3 col-xs-6"
                  v-for="(item, index) in gcjsList"
                  :key="index"
                >
                  <div class="gcjsImg">
                    <img
                      v-lazy="item.image[0]"
                      alt=""
                      style="width: 100%; height: 100%"
                      :key="index"
                    />
                  </div>
                  <div class="gcjsp gcjsHeight" style="white-space: pre-line">
                    <p>{{ item.text }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 認證獎項 -->
          <div class="row" id="rzjx">
            <div class="col-lg-12 rzTop">
              <h1><span>国際認証と建築賞</span></h1>
              <p>
                華胤は、アメリカ鋼構造協会（AISC）認証、アメリカ溶接協会（AWS）認証、カナダ溶接局（CWB）、日本鋼構評価検査協会（JSA）、ヨーロッパISO品質管理システムなどを含む、鋼構造関連分野で{{
                  zzzsList.length
                }}件の専門認証を取得しています。各認証の申請や年次更新の審査を通じて、私たちは品質システムの運用をより円滑にすることができ、国際認証機関の品質専門家から学び成長する機会を得ています。これらの努力は、品質管理の徹底へのこだわりと国際の高付加価値市場への挑戦への決意を表しています。
              </p>
              <p>
                華胤は創立以来、製品の品質および工事プロジェクトのサービス水準の向上に絶えず努力しており、政府や専門機関から何度も表彰されています。国際的に有名な工事総合請負業者の代表的なプロジェクトを受注する際にも、顧客から高く評価され、優良サプライヤー賞を授与されています。チームは困難を克服してプロジェクトの実行力を推進し、何度も施主や工事総合請負業者から感謝状を受けています。華胤は建築工事分野でも継続的に成長しており、毎年ゴールドスチール賞、トップ10影響力ブランド、トップ10優秀企業など、合計32の賞を受賞して評価されています。
              </p>
            </div>
          </div>

          <!-- 國際認證 -->
          <div>
            <h2>
              <span class="hspan"
                ><span style="color: red">///////// </span>国際認証</span
              >
            </h2>
          </div>
          <div class="container-fluid">
            <div
              class="col-lg-4 col-xs-6"
              v-for="(item, index) in zzzsList"
              :key="index"
            >
              <div class="portfolio-item">
                <div class="thumb">
                  <div class="image">
                    <div class="demo-image__preview gjrzImg">
                      <el-image
                        lazy
                        style="height: 100%"
                        :src="item.image[0]"
                        :preview-src-list="item.image"
                        fit="contain"
                      >
                        <div slot="placeholder">
                          <img src="@/components/img/loading.gif" alt="" />
                        </div>
                        <div slot="error">
                          <img src="@/components/img/error.gif" alt="" />
                        </div>
                      </el-image>
                    </div>
                  </div>
                  <div class="hover-effect">
                    <div
                      class="hover-content zzzsHeight"
                      style="white-space: pre-line"
                    >
                      <h1>{{ item.text }}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 建築獎項 -->
          <div>
            <h2>
              <span class="hspan"
                ><span style="color: red">///////// </span>建築賞</span
              >
            </h2>
          </div>
          <div class="container-fluid">
            <div
              class="col-lg-1-5 col-xs-4"
              v-for="(item, index) in jzjxList"
              :key="index"
            >
              <div class="portfolio-item">
                <div class="thumb">
                  <div class="image">
                    <div class="demo-image__preview jzjxImg">
                      <el-image
                        style="height: 100%"
                        :src="item.image[0]"
                        :preview-src-list="item.image"
                        lazy
                      >
                        <div slot="placeholder">
                          <img src="@/components/img/loading.gif" alt="" />
                        </div>
                        <div slot="error">
                          <img src="@/components/img/error.gif" alt="" />
                        </div>
                      </el-image>
                    </div>
                  </div>
                  <div class="hover-effect">
                    <div
                      class="hover-content jzjxHeight"
                      style="white-space: pre-line"
                    >
                      <h1>{{ item.text }}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 感謝狀 -->
          <div>
            <h2>
              <span class="hspan2"
                ><span style="color: red">///////// </span>工程感謝状 |
                トロフィー</span
              >
            </h2>
          </div>
          <div class="container-fluid">
            <div
              class="col-lg-1-5 col-xs-4"
              v-for="(item, index) in gxzList"
              :key="index"
            >
              <div class="portfolio-item">
                <div class="thumb">
                  <div class="image">
                    <div class="demo-image__preview jzjxImg">
                      <el-image
                        lazy
                        style="height: 100%"
                        :src="item.image[0]"
                        :preview-src-list="item.image"
                      >
                        <div slot="placeholder">
                          <img src="@/components/img/loading.gif" alt="" />
                        </div>
                        <div slot="error">
                          <img src="@/components/img/error.gif" alt="" />
                        </div>
                      </el-image>
                    </div>
                  </div>
                  <div class="hover-effect">
                    <div
                      class="hover-content jzjxHeight"
                      style="white-space: pre-line"
                    >
                      <h1>{{ item.text }}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 小滾輪 -->
      <div id="ss_menu">
        <div>
          <i><a @click="forId('lsyg')">沿革</a></i>
        </div>
        <div>
          <i
            ><a @click="forId('hymb')">企業<br />理念</a></i
          >
        </div>
        <div>
          <i><a @click="forId('hyyj')">ビジョン</a></i>
        </div>
        <div>
          <i
            ><a @click="forId('esg')">環境<br />社会</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('gcjs')">工場<br />紹介</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('rzjx')">認證<br />栄誉</a></i
          >
        </div>
        <div class="menu">
          <div class="share" id="ss_toggle" data-rot="180">
            <div class="circle"></div>
            <div class="bar"></div>
          </div>
        </div>
      </div>
    </section>
    <div class="mailbg">
      <to-mail button-text="お問い合わせ"></to-mail>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gcjsList: [
        {
          image: [require('@/components/img/gyhy/gcjs1.png')],
          text: '生産工場\n面積49,000m²',
        },
        {
          image: [require('@/components/img/gyhy/gcjs2.png')],
          text: '塗装作業場\n面積10,000m²',
        },
        {
          image: [require('@/components/img/gyhy/gcjs3.png')],
          text: '製品置き場\n面積15,000m²',
        },
        {
          image: [require('@/components/img/gyhy/gcjs4.png')],
          text: '吊り上げシステム\n20トン',
        },
        {
          image: [require('@/components/img/gyhy/gcjs5.png')],
          text: '塗装作業場\n空気浄化システム',
        },
        {
          image: [require('@/components/img/gyhy/gcjs6.png')],
          text: '12,000W\nレーザ平面切断機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs7.png')],
          text: 'H型鋼三D五軸レーザー切断機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs8.png')],
          text: '自動相貫線切断機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs9.png')],
          text: 'プラズマ型材切断機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs10.png')],
          text: '多門炎切断機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs11.png')],
          text: '20,000W\nレーザー平面切断機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs12.png')],
          text: 'プラズマフレーム数値制御平面切断機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs21.png')],
          text: '形鋼レーザー切断機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs13.png')],
          text: '環境保護用スプレーペイントブース',
        },
        {
          image: [require('@/components/img/gyhy/gcjs14.png')],
          text: 'サンドブラスト機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs15.png')],
          text: 'ロボット溶接機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs16.png')],
          text: 'SAW溶接機',
        },
        {
          image: [require('@/components/img/gyhy/gcjs17.png')],
          text: 'サブマージアーク溶接',
        },
        {
          image: [require('@/components/img/gyhy/gcjs18.png')],
          text: '高速7軸3Dマシニングセンター',
        },
        {
          image: [require('@/components/img/gyhy/gcjs19.png')],
          text: 'CNCマシニングセンター',
        },
        {
          image: [require('@/components/img/gyhy/gcjs22.png')],
          text: 'CNC端面フライス盤',
        },
        {
          image: [require('@/components/img/gyhy/gcjs20.png')],
          text: '組立機',
        },
      ],
      zzzsList: [
        {
          image: [require('@/components/img/gyhy/zzzs5.png')],
          text: 'アメリカ鉄骨構造協会\nAISC',
        },
        {
          image: [require('@/components/img/gyhy/zzzs8.png')],
          text: 'アメリカ溶接協会\nAWS',
        },
        {
          image: [require('@/components/img/gyhy/zzzs6.png')],
          text: 'カナダ溶接局\nCWB\nCSA W47.1',
        },
        {
          image: [require('@/components/img/gyhy/zzzs9.png')],
          text: '中国鋼構造協会\n一級製作資格',
        },
        {
          image: [require('@/components/img/gyhy/zzzs10-1.png')],
          text: '欧州鉄骨構造製作規格CEマーキング適合\nEN1090-1',
        },
        {
          image: [require('@/components/img/gyhy/zzzs10-2.png')],
          text: '欧州鉄骨構造製作規格CEマーキング適合\nEN1090-2',
        },
        {
          image: [
            require('@/components/img/gyhy/zzzs14.png'),
            require('@/components/img/gyhy/zzzs15.png'),
          ],
          text: '日本鉄骨評価センター国土交通省認定\n JSA',
        },
        {
          image: [
            require('@/components/img/gyhy/zzzs13.png'),
            require('@/components/img/gyhy/zzzs12.png'),
          ],
          text: '欧州品質マネジメントシステムの国際規格\nISO 9001',
        },
        {
          image: [
            require('@/components/img/gyhy/zzzsen2.png'),
            require('@/components/img/gyhy/zzzs2.png'),
            require('@/components/img/gyhy/zzzs4.png'),
          ],
          text: '欧州労働安全衛生\nマネジメントシステム\nISO 45001',
        },
        {
          image: [
            require('@/components/img/gyhy/zzzsen1.png'),
            require('@/components/img/gyhy/zzzs1.png'),
            require('@/components/img/gyhy/zzzs3.png'),
          ],
          text: '欧州環境マネジメン\nトシステム\nISO 14001',
        },
        {
          image: [require('@/components/img/gyhy/zzzs11.png')],
          text: '欧州金属材料の融接に関する品質要求事項\nISO 3834',
        },
        {
          image: [require('@/components/img/gyhy/zzzs16.png')],
          text: 'カナダ鋼構造建築システム製造業者認証\nCSA A660-10',
        },
      ],
      jzjxList: [
        {
          image: [require('@/components/img/gyhy/ryzs1.jpg')],
          text: '1998華胤廈門\n福建省で最も売れている不動産商品',
        },
        {
          image: [require('@/components/img/gyhy/ryzs2.jpg')],
          text: '2000年 昆山華胤\n上海鋼構協会金鋼賞',
        },
        {
          image: [require('@/components/img/gyhy/ryzs3.jpg')],
          text: '2001年 昆山華胤\n上海鋼構協会金鋼賞',
        },
        {
          image: [require('@/components/img/gyhy/ryzs4.jpg')],
          text: '2002年 上海華胤\n貨物運送金鋼賞',
        },
        {
          image: [require('@/components/img/gyhy/ryzs5.jpg')],
          text: '2002年 上海華胤\n中国貨物航空浦東物流センター 金鋼賞',
        },
        {
          image: [require('@/components/img/gyhy/ryzs6.jpg')],
          text: '2003年 華胤昆山\n創姿服飾金剛賞',
        },
        {
          image: [require('@/components/img/gyhy/ryzs7.jpg')],
          text: '2003年 華胤昆山\n恵生科技園金剛賞証書',
        },
        {
          image: [require('@/components/img/gyhy/ryzs8.jpg')],
          text: '2003上海華胤\n名辰模塑金鋼賞證書',
        },
        {
          image: [require('@/components/img/gyhy/ryzs9.jpg')],
          text: '2004昆山華胤\n嘉麒大廈金鋼賞',
        },
        {
          image: [require('@/components/img/gyhy/ryzs10.jpg')],
          text: '2004昆山華胤\n賽科金鋼賞',
        },
        {
          image: [require('@/components/img/gyhy/ryzs11.jpg')],
          text: '2004年 厦門華胤\n金剛賞 - 同仁堂',
        },
        {
          image: [require('@/components/img/gyhy/ryzs12.jpg')],
          text: '2005華胤グループ\n十大優秀企業',
        },
        {
          image: [require('@/components/img/gyhy/ryzs13.jpg')],
          text: '2005華胤グループ\n十大影響力ブランド',
        },
        {
          image: [require('@/components/img/gyhy/ryzs14.jpg')],
          text: '2005年 華胤廈門\n金属構造優秀単位証書',
        },
        {
          image: [require('@/components/img/gyhy/ryzs15.jpg')],
          text: '2005華胤廈門\n閩江杯栄誉証書',
        },
        {
          image: [require('@/components/img/gyhy/ryzs16.jpg')],
          text: '2006 華胤昆山\nイケアプロジェクト ゴールド賞',
        },
        {
          image: [require('@/components/img/gyhy/ryzs17.jpg')],
          text: '2006 華胤厦門\nECCO 閩江杯',
        },
        {
          image: [require('@/components/img/gyhy/ryzs18.jpg')],
          text: '2006華胤厦門\n福建省先進建築企業表彰証',
        },
        {
          image: [require('@/components/img/gyhy/ryzs19.jpg')],
          text: '2006 華胤廈門\n福建省有名な商標証書',
        },
        {
          image: [require('@/components/img/gyhy/ryzs20.jpg')],
          text: '2006 華胤廈門\n福建省有名な商標証書',
        },
        {
          image: [require('@/components/img/gyhy/ryzs21.jpg')],
          text: '2006 華胤厦門\n専門請負トップ20',
        },
        {
          image: [require('@/components/img/gyhy/ryzs22.jpg')],
          text: '2007年廈門華胤\n専門請負20強',
        },
        {
          image: [require('@/components/img/gyhy/ryzs23.jpg')],
          text: '2008 華胤厦門\n福建の有名ブランド製品',
        },
        {
          image: [require('@/components/img/gyhy/ryzs24.jpg')],
          text: '2008年華胤廈門\n耐震救助先進集団',
        },
        {
          image: [require('@/components/img/gyhy/ryzs25.jpg')],
          text: '2008華胤廈門\nメーデー労働賞状',
        },
        {
          image: [require('@/components/img/gyhy/ryzs26.jpg')],
          text: '蘇州華胤\n港務品質等級証明書',
        },
      ],
      gxzList: [
        {
          image: [require('@/components/img/gyhy/gxz1.jpg')],
          text: '1996年 蘇州華邦\n高日自動車 感謝状',
        },
        {
          image: [require('@/components/img/gyhy/gxz2.jpg')],
          text: '2001 華胤プロジェクト\n億光電子感謝状',
        },
        {
          image: [require('@/components/img/gyhy/gxz3.jpg')],
          text: '2002年華胤廈門\n六和機械感謝状',
        },
        {
          image: [require('@/components/img/gyhy/gxz4.jpg')],
          text: '2004年 華胤昆山\n蘇州鑫端機密感謝状',
        },
        {
          image: [require('@/components/img/gyhy/gxz5.jpg')],
          text: '2005年華胤昆山\nトヨタ自動車感謝状',
        },
        {
          image: [require('@/components/img/gyhy/gxz6.jpg')],
          text: '2005年華胤崑山\n寧波華揚感謝状',
        },
        {
          image: [require('@/components/img/gyhy/gxz7.jpg')],
          text: 'IBM感謝状',
        },
        {
          image: [require('@/components/img/gyhy/gxz8.jpg')],
          text: '飛鵬アルミニウム感謝状',
        },
        {
          image: [require('@/components/img/gyhy/gxz9.jpg')],
          text: 'Fluor\nBASF Jade Tree Project\n“機械竣工記念”',
        },
        {
          image: [require('@/components/img/gyhy/gxz10.jpg')],
          text: '三菱重工\nThe GPUFP Project\n“感謝賞”',
        },
        {
          image: [require('@/components/img/gyhy/gxz11.jpg')],
          text: 'Fluor\nBASF IOU Project\n“サプライヤー優秀賞”',
        },
        {
          image: [require('@/components/img/gyhy/gxz12.jpg')],
          text: 'Fluor\nBASF Maoming Project\n“サプライヤー優秀賞”',
        },
        {
          image: [require('@/components/img/gyhy/gxz13.jpg')],
          text: 'Fluor\nAlbemarle MSH Project\n“卓越な貢献サプライヤー”',
        },
        {
          image: [require('@/components/img/gyhy/gxz14.jpg')],
          text: 'Turner and Townsend\nStarbucks Kunshan Project\n“安全作業時間50万時間”',
        },
        {
          image: [require('@/components/img/gyhy/gxz15.jpg')],
          text: 'Fluor\nBASF Infra Cluster Project\n“安全作業時間三千万時間”',
        },
        {
          image: [require('@/components/img/gyhy/gxz16.jpg')],
          text: 'Christiaens (China) Production Co., Ltd.\n“25 Tunnels - Phase 23 Project”',
        },
      ],
    }
  },
  methods: {
    // 調用全局方法,滾動指定id
    forId(tId) {
      this.$store.dispatch('toID', tId)
    },
  },
  updated() {
    if (this.scrollToElement) {
      this.scrollToElement()
      this.scrollToElement = null
    }
  },
}
</script>

<style scoped>
/* 榮譽圖片註釋設置 */
.slideImg {
  width: 100%;
  height: 100%;
  margin-bottom: -30px;
  padding-bottom: 30px;
}
.slideP {
  text-align: center;
  color: #000;
  font-size: 16px;
  line-height: 30px;
}

#rzjx,
#gcjs {
  border-top: 1px solid black;
}
.esgImgCon {
  text-align: center;
  margin-top: 0px;
  margin-bottom: 100px;
}
.esgImg {
  width: 70vw;
}

/* 榮譽圖片註釋設置 */
.cbp-spmenu-push {
  overflow-x: hidden;
  position: relative;
  left: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.cbp-spmenu-push .banner {
  background: url(@/components/img/gyhy/1.jpg) 0px 0px no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  height: 500px;
  position: relative;
  width: 100%;
  background-size: 100% 100%;
}

/*-- banner-info --*/
.banner-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.banner-info span {
  font-size: 50px;
  color: #fff;
  padding: 3px 15px;
  margin: 0 auto;
  line-height: normal;
  background: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}

/*-- banner-bottom --*/
.banner-bottom-left p {
  color: #fff;
  font-size: 14px;
  margin: 0;
  line-height: 1.8em;
}
.banner-bottom-left1 {
  border: 5px solid black;
  padding: 8em 5em 5em;
  background: #415160;
}
.banner-bottom-left2 {
  padding: 0;
}
.globe span {
  background: url(@/components/img/gyhy/img-sp.png) no-repeat 22px -81px;
  display: block;
  width: 128px;
  height: 128px;
  border: 1px solid #3f647d;
  border-radius: 100%;
}
.banner-bottom-left1-grid h3 {
  margin: 80px 0 40px;
  color: #fff;
  font-size: 40px;
  text-transform: capitalize;
}
.progress1 {
  height: 2px;
  margin-bottom: 0;
  border-radius: 0;
  margin: 1.5em 0 0;
}
.progress-bar1 {
  background: #eb6f63;
}
.banner-bottom-left1-grid p {
  margin: 40px 0 0;
  color: #fff;
  font-size: 23px;
  line-height: 36px;
}
.banner-bottom-left2 h3 {
  padding: 20px 20px 0;
  font-size: 34px;
  color: #212121;
  margin: 0;
  line-height: 40px;
  position: relative;
}

/*-- effect --*/
.grid {
  position: relative;
  clear: both;
  margin: 0 auto;
  list-style: none;
  text-align: center;
  height: 100%;
}

/* Common style */
.grid figure {
  position: relative;
  float: none;
  margin: 0;
  min-width: 273px;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  text-align: center;
}

.grid figure img {
  position: relative;
  display: block;
  min-height: 100%;
  max-width: 100%;
  width: auto;
  opacity: 0.8;
}

.grid figure figcaption {
  padding: 2em;
  color: #fff;
  text-transform: uppercase;
  font-size: 1.25em;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.grid figure figcaption::before {
  pointer-events: none;
}

.grid figure figcaption,
.grid figure figcaption > a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
/***** Lexi *****/
/*---------------*/

/*-- //effect --*/
/*-- //banner-bottom --*/
/*-- banner-bottom1 --*/
.banner-bottom-lft1 h3 {
  font-size: 5em;
  color: #fff;
  margin: 0;
}
.banner-bottom-left1,
.banner-bottom-lft1 {
  padding: 2.17em 4em 4em;
  /* background: #415160; */
  border-top: 10px double #58c5c8; /* 頂部5px寬的橙色雙線條邊框 */
  border-radius: 10px 10px 0 0; /* 頂部兩角更大的圓角 */
  border-bottom: none; /* 去除底部邊框 */
  border-left: none; /* 去除左邊框 */
  border-right: none; /* 去除右邊框 */

  /* 2. 更精致的背景效果 */
  background: radial-gradient(
    circle,
    #415160 0%,
    #415160 100%
  ); /* 從中心向外的白色到淺灰色漸變背景 */

  /* 4. 文本陰影效果 */
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);

  /* 5. 盒子陰影效果,更立體 */
  box-shadow: 0px -8px 8px -8px rgba(0, 0, 0, 0.2);

  /* 6. 透明度設置 */
  opacity: 0.95;
}
.banner-bottom-lft1 h4 {
  font-size: 40px;
  color: #fff;
  text-align: left;
  margin: 80px 0 40px;
}
.progress2 {
  margin: 1em 0 0;
}
.banner-bottom-lft1 p {
  margin: 40px 0 20px;
  color: #fff;
  font-size: 23px;
  line-height: 36px;
}
h4.with {
  text-align: left;
}

/* 小滾輪 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px !important;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #415160;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 13px;
  text-align: center;
  background: #415160;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #2a2f34;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: 0px;
  left: -205px;
}

#ss_menu div:nth-child(2) {
  top: -62px;
  left: -193px;
}

#ss_menu div:nth-child(3) {
  top: -123px;
  left: -170px;
}

#ss_menu div:nth-child(4) {
  top: -170px;
  left: -123px;
}

#ss_menu div:nth-child(5) {
  top: -193px;
  left: -62px;
}
#ss_menu div:nth-child(6) {
  top: -205px;
  left: 0px;
}

.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

@property --s {
  syntax: '<length>';
  initial-value: 0px;
  inherits: true;
}

.showImg {
  --t: 3px; /* control the thickness (corner = 3*edge) */
  --s: 40px; /* control the size of the corners (that also affect the size of the edges) */
  --g: 8px; /* control the gap */
  --c: #755c3b;

  padding: calc(2 * var(--t) + var(--g));
  border: var(--t) solid #0000;
  background: conic-gradient(
        at var(--s) calc(3 * var(--t)),
        #0000 75%,
        var(--c) 0
      )
      0 0 / calc(100% - var(--s)) calc(100% - 3 * var(--t)) border-box,
    conic-gradient(at calc(3 * var(--t)) var(--s), #0000 75%, var(--c) 0) 0 0 /
      calc(100% - 3 * var(--t)) calc(100% - var(--s)) border-box,
    linear-gradient(0deg, var(--c) calc(2 * var(--t)), #0000 0) 50% var(--t) /
      calc(100% - 2 * (var(--s) + var(--g))) 100% repeat-y padding-box,
    linear-gradient(-90deg, var(--c) calc(2 * var(--t)), #0000 0) var(--t) 50%/100%
      calc(100% - 2 * (var(--s) + var(--g))) repeat-x padding-box;
  transition: --s 0.5s;
  cursor: pointer;
}
.showImg:hover {
  --s: 80px;
}

.rzTop {
  margin: 50px 0;
  text-align: center;
}
.rzTop h1 {
  margin: 50px 0;
}
.rzTop h1 span {
  padding-bottom: 0;
  font-size: 37px;
  font-weight: 900;
}
.rzTop p {
  margin: 0 auto;
  width: 85vw;
  text-align: left;
  font-size: 26px;
  line-height: 40px;
}

.spaceCon {
  margin: 60px auto 0;
}

.gcjsTop {
  margin: 50px 0;
  text-align: center;
}
.gcjsTop h1 {
  margin: 50px 0;
}
.gcjsTop h1 span {
  padding-bottom: 10px;
  font-size: 34px;
  font-weight: 800;
}
.gcjsTop p {
  margin: 0 auto;
  width: 60vw;
  text-align: left;
  font-size: 22px;
  font-weight: 600;
  line-height: 40px;
}
.zzzsHeight {
  height: 100px;
}
.gcjsHeight {
  height: 100px;
}
.jzjxHeight {
  height: 130px;
}
.hover-content h1 {
  font-size: 24px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.onlyPC {
  display: flex;
}

.hspan,
.hspan2 {
  margin: 30px 10px;
  display: inline-block;
  position: relative;
  padding: 10px 20px;
  font-size: 35px;
  font-weight: 600;
}

.gjrzImg,
.jzjxImg {
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}
.gcjsImg {
  position: relative; /* 父容器設為相對定位 */
  width: 100%;
  height: 15vw; /* 按需設置高度 */
  margin: 0;
  text-align: center;
  background-color: #fff;
}
.gcjsp {
  margin: 20px 0;
}
.gcjsp p {
  width: auto;
  text-align: center;
  font-size: 24px;
}

div /deep/ .gjrzImg img {
  padding: 5px;
  width: 100%;
  height: 20vw;
  border: 0;
}

div /deep/ .jzjxImg img {
  padding: 5px;
  width: 100%;
  height: 10vw;
  border: 0;
}

.container-fluid {
  margin: 60px auto 0;
}

/* 漸變背景 */
.gradient-background {
  padding: 0 100px 100px;
  margin-top: 10px;
  border-top: 1px solid #000;
  width: 100%;
  height: 100%; /* 設置高度為視口高度 */
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.mailbg {
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

@media screen and (max-width: 1400px) {
  .grid figure img {
    width: 100%;
  }
  .gradient-background {
    padding: 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .rzTop h1 span {
    padding-bottom: 0;
    font-size: 26px;
    font-weight: 600;
  }
  .rzTop p {
    margin: 0 auto;
    width: 90vw;
    text-align: left;
    font-size: 19px;
    font-weight: 500;
    line-height: 1.5;
  }

  .onlyPC {
    display: inline;
  }
  .container {
    width: 100%;
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan,
  .hspan2 {
    margin: 10px;
    font-size: 22px;
  }
  .gcjsp p {
    width: auto;
    text-align: center;
    font-size: 18px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 10px;
  }
  .gcjsImg {
    height: 30vw;
  }
  .gcjsp {
    margin: 10px 0;
  }
  .gcjsHeight {
    height: 60px;
  }
  div /deep/ .gjrzImg img {
    height: 50vw;
  }
  .hover-content h1 {
    font-size: 18px;
    margin: 10px 0;
  }
  .zzzsHeight {
    height: 80px;
  }
  .container-fluid {
    margin: 20px auto;
  }
  .jzjxHeight {
    height: 100px;
  }
  div /deep/ .jzjxImg img {
    height: 21vw;
  }
  .rzTop {
    margin: 0;
  }
  .row {
    margin: 0 !important;
  }
  .esgImgCon {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .esgImg {
    width: 70vw;
  }
  .banner-info span {
    font-size: 36px;
  }
  .cbp-spmenu-push .banner {
    height: 350px;
  }
  .mobh {
    font-size: 30px !important;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -252px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 26px;
    margin: 40px 0 20px;
  }
  .progress1 {
    margin: 1em 0 0;
  }
  .banner-bottom-left1-grid p {
    margin: 20px 0 10px 0;
    font-size: 19px;
    line-height: 1.5;
  }
  .banner-bottom-left1 {
    padding: 2em;
  }
  .m1 a {
    padding: 0px 80px 10px !important;
  }
  .grid figure figcaption {
    padding: 0em 1em;
  }
  .banner-bottom-left2 h3 {
    font-size: 1em;
    line-height: 1.8em;
  }
  .banner-bottom-lft1 {
    padding: 2em;
  }
  .banner-bottom-lft1 h4 {
    font-size: 26px;
    margin: 40px 0 20px;
  }
  .banner-bottom-lft1 p {
    font-size: 19px;
    line-height: 1.5;
  }
  .equipmentList .equipmentListItem .ListItem .Item h5 {
    font-size: 18px;
  }
}

@media screen and (max-width: 768px) {
  .grid figure img {
    width: auto;
  }
  .gradient-background {
    padding: 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .rzTop h1 span {
    padding-bottom: 0;
    font-size: 20px;
    font-weight: 600;
  }
  .rzTop p {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
  }

  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan,
  .hspan2 {
    margin: 10px;
    font-size: 20px;
  }
  .gcjsp p {
    width: auto;
    text-align: center;
    font-size: 13px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 5px;
  }
  .gcjsImg {
    height: 30vw;
  }
  .gcjsp {
    margin: 10px 0;
  }
  .gcjsHeight {
    height: 40px;
  }
  div /deep/ .gjrzImg img {
    height: 60vw;
  }
  .hover-content h1 {
    font-size: 13px;
    margin: 10px 0;
  }
  .zzzsHeight {
    height: 65px;
  }
  .container-fluid {
    margin: 20px auto;
  }
  .jzjxHeight {
    height: 100px;
  }
  div /deep/ .jzjxImg img {
    height: 21vw;
  }
  .rzTop {
    margin: 0;
  }
  .row {
    margin: 0 !important;
  }
  .esgImgCon {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .esgImg {
    width: 70vw;
  }
  .banner-info span {
    font-size: 26px;
  }
  .cbp-spmenu-push .banner {
    height: 200px;
  }
  .mobh {
    font-size: 30px !important;
  }
  .banner-bottom-left1-grid p {
    margin: 40px 0 20px !important;
    font-size: 12px !important;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -252px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 20px;
    margin: 40px 0 20px;
  }
  .progress1 {
    margin: 1em 0 0;
  }
  .banner-bottom-left1-grid p {
    margin: 20px 0 0;
    font-size: 13px;
    line-height: 22px;
  }
  .banner-bottom-left1 {
    padding: 2em;
  }
  .m1 a {
    padding: 0px 80px 10px !important;
  }
  .grid figure figcaption {
    padding: 0em 1em;
  }
  .banner-bottom-left2 h3 {
    font-size: 1em;
    line-height: 1.8em;
  }
  .banner-bottom-lft1 {
    padding: 1em 1em 2em;
  }
  .banner-bottom-lft1 h4 {
    font-size: 20px;
    margin: 40px 0 20px;
  }
  .banner-bottom-lft1 p {
    font-size: 13px;
    line-height: 22px;
  }
  .equipmentList .equipmentListItem .ListItem .Item h5 {
    font-size: 18px;
  }
}

@media screen and (min-width: 2000px) {
  .banner-bottom-left1-grid p {
    font-size: 29px;
    line-height: 1.8;
  }
  .banner-bottom-left1 {
    padding: 5em;
  }
  .banner-bottom-left1-grid h3 {
    margin: 90px 0 50px;
  }
  .banner-bottom-lft1 h4 {
    margin: 90px 0 50px;
  }
  .banner-bottom-lft1 p {
    font-size: 29px;
    line-height: 1.8;
  }
  .rzTop h1 span {
    font-size: 40px;
  }
  .rzTop p {
    font-size: 29px;
    line-height: 1.8;
  }
  .gradient-background {
    padding: 0 160px 100px;
  }
  .gcjsp p {
    font-size: 26px;
    line-height: 1.5;
  }
  .hover-content h1 {
    font-size: 26px;
    line-height: 1.5;
  }
  .zzzsHeight {
    height: 140px;
  }
  .jzjxHeight {
    height: 140px;
  }
  .banner-info span {
    font-size: 65px;
  }
}
</style>
